import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { MitsPDFViewerModule } from '../mits-pdf-viewer/mits-pdf-viewer.module';
import { MitsPDFGenerator } from './helpers/mits-pdf-generator';

@NgModule({
  imports: [CommonModule, MitsPDFViewerModule],
  declarations: [],
  entryComponents: [],
  exports: [MitsPDFViewerModule],
  providers: [MitsPDFGenerator, DatePipe],
})
export class MitsPDFModule {}
